'use strict';

(function () {
  var accordion = document.querySelector('.accordion');

  if (!accordion) {
    return;
  }

  var accordionReveal = accordion.querySelectorAll('.accordion__item-btn');

  // set aria attr
  var setAttr = function setAttr(el) {

    el.parentNode.classList.toggle("is-active");

    var is_active = el.parentNode.classList.contains("is-active");

    var answer_element = el.parentNode.querySelector('.js-accordion-answer');

    answer_element.setAttribute('aria-hidden', is_active ? 'false' : 'true');
    answer_element.style.display = is_active ? 'block' : 'none';

    el.setAttribute('aria-expanded', is_active ? 'true' : 'false');
  };

  var toggle_answer = function toggle_answer(el) {};

  accordionReveal.forEach(function (el, i) {
    el.addEventListener('click', function () {
      setAttr(el);
    });

    // space or return
    el.addEventListener('keydown', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        setAttr(el);
        e.preventDefault();
      }
    });
  });
})();